import { render, staticRenderFns } from "./CortinaLimitations.vue?vue&type=template&id=0d381707&"
import script from "./CortinaLimitations.vue?vue&type=script&lang=js&"
export * from "./CortinaLimitations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports